import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { I18NService } from '@core';
import { ALAIN_I18N_TOKEN, I18nPipe } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';

@Component({
  selector: 'avatar-upload-modal',
  standalone: true,
  imports: [CommonModule, NzModalModule, NzButtonModule, NzIconModule, ImageCropperComponent, I18nPipe, TestIdDirective],
  templateUrl: './avatar-upload-modal.component.html',
  styleUrls: ['./avatar-upload-modal.component.less']
})
export class AvatarUploadModalComponent {
  private readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);
  @Input() visible = false;
  @Input() title = this.i18n.fanyi('avatar.upload.title');
  @Input() uploading = false;
  @Input() aspectRatio = 1;
  @Input() resizeToWidth = 256;

  @Output() readonly visibleChange = new EventEmitter<boolean>();
  @Output() readonly cancel = new EventEmitter<void>();
  @Output() readonly ok = new EventEmitter<{ blob: Blob; width: number }>();

  private readonly message = inject(NzMessageService);

  @ViewChild('fileInput') fileInput!: ElementRef;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedBlob: Blob | null = null;
  croppedWidth: number = 0; // 添加裁切后图片宽度属性

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    // 在处理完事件后，清空文件输入框的值，这样即使选择相同的文件也会触发change事件
    setTimeout(() => {
      if (this.fileInput && this.fileInput.nativeElement) {
        this.fileInput.nativeElement.value = '';
      }
    }, 100);
  }

  imageCropped(event: ImageCroppedEvent): void {
    this.croppedImage = event.base64;
    if (event.blob) {
      this.croppedBlob = event.blob;
    }
    // 获取裁切后图片的宽度
    if (event.width) {
      this.croppedWidth = event.width;
    }
  }

  loadImageFailed(): void {
    console.error(this.i18n.fanyi('avatar.upload.load-failed'));
  }

  resetAndSelectImage(): void {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.croppedBlob = null;
    this.croppedWidth = 0; // 重置宽度

    // 确保文件输入框的值被清空
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }

    setTimeout(() => {
      this.fileInput.nativeElement.click();
    }, 100);
  }

  handleCancel(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.cancel.emit();
    this.resetImage();
  }

  // 然后修改 handleOk 方法
  handleOk(): void {
    if (this.croppedBlob) {
      this.ok.emit({
        blob: this.croppedBlob,
        width: this.croppedWidth
      });
      this.resetImage();
    } else {
      this.message.warning(this.i18n.fanyi('avatar.upload.select-and-crop-first'));
      return;
    }
  }

  resetImage(): void {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.croppedBlob = null;
    this.croppedWidth = 0; // 重置宽度
  }
}
